import * as React from 'react';

import { Button } from '@coursera/cds-core';
import type { ButtonProps, LinkProps } from '@coursera/cds-core';
import { ExternalLinkIcon, UnlinkIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/slack-account-link';

export const UnlinkSlackButton = ({ onClick }: Pick<ButtonProps, 'onClick'>) => (
  <Button
    variant="ghost"
    type="button"
    icon={<UnlinkIcon size="medium" />}
    iconPosition="before"
    onClick={onClick}
    data-testid="slack-account-email-unlink"
  >
    {_t('Unlink')}
  </Button>
);

export const OpenSlackLink = ({ href }: Pick<LinkProps, 'href'>) => (
  <Button
    component="a"
    href={href}
    icon={<ExternalLinkIcon size="medium" />}
    iconPosition="after"
    variant="secondary"
    aria-label={_t('Open Slack in new window')}
    data-testid="launch-slack-button"
  >
    {_t('Open Slack')}
  </Button>
);
